import React from "react";
import { Box, Flex, Text, Link } from "@chakra-ui/react";

function Card({ data, activeTab, navigate }) {
  return (
    <Box
      borderWidth="1px"
      borderRadius="16px"
      p={4}
      mb={4}
      bg="white"
      boxShadow="sm"
    >
      {/* Header */}
      <Flex justify="space-between" align="flex-start" gap={3} mb={2}>
        <Text fontWeight="700" fontSize="md" color="#141D43" noOfLines={2}>
          {data.audit_company?.name ||
            data.audit_application?.name ||
            data.audit_scope?.scop_company?.name ||
            "—"}
        </Text>

        <Text fontSize="xs" color="gray.500" whiteSpace="nowrap" mt="2px">
          {data.dateTime}
        </Text>
      </Flex>

      {/* Application Number */}
      <Text fontSize="sm" mb={1}>
        <Text as="span" fontWeight="600">
          Application Number:
        </Text>{" "}
        {data.audit_company?.id ||
          data.audit_application?.id ||
          data.audit_scope?.id ||
          "—"}
      </Text>

      {/* Unit Type */}
      <Text fontSize="sm" mb={1}>
        <Text as="span" fontWeight="600">
          Unit Type:
        </Text>{" "}
        {data.audit_unit?.unitType || "—"}
      </Text>

      {/* Facility/Site */}
      <Text fontSize="sm" mb={1}>
        <Text as="span" fontWeight="600">
          Facility/Site:
        </Text>{" "}
        {data.audit_unit?.name || "—"}
      </Text>

      {/* Address */}
      <Text fontSize="sm" color="gray.600" noOfLines={2} mb={3}>
        <Text as="span" fontWeight="600" color="gray.700">
          Address:
        </Text>{" "}
        {data.audit_unit?.address?.raw_address || "—"}
      </Text>

      {/* Action */}
      <Flex justify="flex-end" mt={4}>
        <Link
          color="#3958DC"
          fontWeight="700"
          fontSize="sm"
          onClick={() => {
            const id = encodeURIComponent(data.id);
            navigate(`/auditor/rc-form-details/${id}`);
          }}
        >
          View Details
        </Link>
      </Flex>
    </Box>
  );
}

export default Card;
